import { ApexOptions } from "apexcharts"
import { useMemo } from "react"
import ReactApexChart from "react-apexcharts"
import { ApexChartType } from "src/shared/config/DefaultApexOptions"
import { colorMapper } from "src/shared/enums/networkColors"
import { monitorApexOptions } from "../../../chartDateAxis"

export const AudienceByNetwork = ({ series }: ApexOptions) => {
  const audienceByNetworkOptions = useMemo<ApexOptions>(
    () => monitorApexOptions({ colors: colorMapper(series) }, ApexChartType.bar),
    [],
  )

  return (
    <div>
      <ReactApexChart
        options={audienceByNetworkOptions}
        series={series}
        type="bar"
        height={400}
      />
    </div>
  )
}
